module.exports = __webpack_public_path__ + "static/icon-big-love.0ebd39c0.svg";